import styled from 'styled-components';

const MenuTriggerButton = styled.button`
  border-radius: 50%;
  height: 40px;
  width: 40px;
  border: 1px solid rgb(217, 217, 217);
  cursor: pointer;
  background: ${({ theme }) => theme.colors.white[100]};
  transition-duration: 1s;
  &.add-icon-open {
    transform: rotate(45deg);
  }
  svg {
    cursor: pointer;
  }
`;

export default MenuTriggerButton;
